/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const LockClosedIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M8.11 2.86a5.5 5.5 0 0 1 9.39 3.89v2.76a3.25 3.25 0 0 1 3 3.24v6.75a3.25 3.25 0 0 1-3.25 3.25H6.75A3.25 3.25 0 0 1 3.5 19.5v-6.75a3.25 3.25 0 0 1 3-3.24V6.75a5.5 5.5 0 0 1 1.61-3.89M8.5 9.5V6.75a3.5 3.5 0 1 1 7 0V9.5zm3.5 8.25a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5" clipRule="evenodd" /></svg>;
};
export default LockClosedIcon;